import React, { useState } from "react";

export default function CreateCardForm() {
  const [card, setCard] = useState({
    name: "",
    types: [""],
    subtypes: [""],
    rank: "",
    summonerSkills: [{ level: "", skill: "", skillDetail: "" }],
    healingPoints: 0,
    abilities: [""],
    baseEffects: [{ effect: "", effectDetail: "" }],
    actions: [
      {
        tossOfCoin: [{ cost: "", success: { description: "", detail: "" }, fail: { description: "", detail: "" } }],
        directPurchase: [{ cost: "", action: "", actionDetail: "" }],
      },
    ],
  attack: '',
  defence: '',
    rarity: "",
    flavorText: "",
    illustrator: [""],
    edition: [""],
    releaseYear: new Date().getFullYear(),
    cardNumber: "",
    imageUrl: "",
    collector: 0,
  });

  const handleChange = (e) => {
    setCard({ ...card, [e.target.name]: e.target.value });
  };

  const handleArrayChange = (e, field, index) => {
    const updated = [...card[field]];
    updated[index] = e.target.value;
    setCard({ ...card, [field]: updated });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem("token");
      const res = await fetch("/api/cards/create", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify(card),
      });

      if (res.ok) {
        // Redirection après création vers la liste filtrée par édition
        const edition = Array.isArray(card.edition) ? card.edition[0] : card.edition;
        window.location.href = "/admin/cards?q=&edition=" + encodeURIComponent(edition);
      } else {
        const error = await res.json();
        alert("Erreur : " + error.error);
      }
    } catch (err) {
      console.error(err);
      alert("Erreur réseau");
    }
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-2">
      <input type="text" name="name" value={card.name} onChange={handleChange} placeholder="Nom de la carte" required />
      
      <input
        type="text"
        name="rank"
        value={card.rank}
        onChange={handleChange}
        placeholder="Rang"
      />

      <input
        type="text"
        name="attack"
        value={card.attack === -1 ? '*' : card.attack}
        onChange={handleChange}
        placeholder="Attaque (nombre ou *)"
      />

      <input
        type="text"
        name="defence"
        value={card.defence === -1 ? '*' : card.defence}
        onChange={handleChange}
        placeholder="Défense (nombre ou *)"
      />

      <input
        type="text"
        name="rarity"
        value={card.rarity}
        onChange={handleChange}
        placeholder="Rareté"
      />

      <input
        type="text"
        name="flavorText"
        value={card.flavorText}
        onChange={handleChange}
        placeholder="Texte d'ambiance"
      />

      <input
        type="text"
        name="imageUrl"
        value={card.imageUrl}
        onChange={handleChange}
        placeholder="URL de l'image"
      />

      <button type="submit">Créer la carte</button>
    </form>
  );
}
